import * as React from "react";
import { useFonts } from "expo-font";
import { Slot, SplashScreen } from "expo-router";
import { QueryClient, QueryClientProvider } from "react-query";

import { GlobalHonoProvider } from "~/hooks/HonoContext";
import {
  supabaseClient,
  SupabaseProvider,
  useSessionContext,
} from "~/lib/supabase";

import "./../global.css";

import { AppState } from "react-native";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { SafeAreaProvider } from "react-native-safe-area-context";

import { ColorSettingsProvider } from "~/components/ColorSettings";
import { PageMeta } from "~/components/PageMeta";
import { ReactNavigationThemeProvider } from "~/components/ReactNavigationThemeProvider";
import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import { isWeb } from "~/lib/constants";
import { initSentry, wrapSentry } from "~/lib/sentry/sentry";

initSentry();
SplashScreen.preventAutoHideAsync();

AppState.addEventListener("change", (state) => {
  if (state === "active") {
    supabaseClient.auth.startAutoRefresh();
  } else {
    supabaseClient.auth.stopAutoRefresh();
  }
});

export default wrapSentry(function CustomLayout() {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            refetchInterval: false,
          },
        },
      }),
  );
  // fking expo is shit and isnt picking up our +html.tsx
  React.useEffect(() => {
    if (isWeb) {
      document.documentElement.classList.add("dark");
      document.body.style.overflow = "auto";
    }
  }, []);
  return (
    <ColorSettingsProvider>
      <ReactNavigationThemeProvider>
        <QueryClientProvider client={queryClient}>
          <SupabaseProvider>
            <SplashScreenHandler>
              <GlobalHonoProvider>
                <PageMeta />
                <ResponsiveRenderer
                  webDesktop={<Slot />}
                  default={
                    <SafeAreaProvider>
                      <GestureHandlerRootView style={{ flex: 1 }}>
                        <Slot />
                      </GestureHandlerRootView>
                    </SafeAreaProvider>
                  }
                />
              </GlobalHonoProvider>
            </SplashScreenHandler>
          </SupabaseProvider>
        </QueryClientProvider>
      </ReactNavigationThemeProvider>
    </ColorSettingsProvider>
  );
});

function SplashScreenHandler(props: { children: React.ReactNode }) {
  const { isLoading } = useSessionContext();

  const [fontsLoaded, fontsError] = useFonts({
    "Inter-Black": require("~/assets/Inter/Inter-Black.ttf"),
  });

  if (fontsError) {
    throw fontsError;
  }

  React.useEffect(() => {
    if (isLoading === false && fontsLoaded) {
      SplashScreen.hideAsync();
    }
  }, [isLoading, fontsLoaded]);
  if (isLoading || !fontsLoaded) {
    return null;
  }
  return props.children;
}

export { ErrorBoundary } from "expo-router";
